import { useState, useEffect } from "react";

/**
 * Custom hook for address search with debouncing
 * Searches both client addresses and AWS Location Service
 */
export default function useAddressSearch() {
  const [addressSearch, setAddressSearch] = useState("");
  const [clientAddresses, setClientAddresses] = useState([]);
  const [awsAddresses, setAwsAddresses] = useState([]);
  const [searchingAddresses, setSearchingAddresses] = useState(false);
  const [showAddressDropdown, setShowAddressDropdown] = useState(false);

  // Search addresses API call
  const searchAddresses = async (query) => {
    if (query.length < 2) {
      setClientAddresses([]);
      setAwsAddresses([]);
      return;
    }

    try {
      setSearchingAddresses(true);
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

      const response = await fetch(`/api/address_search?query=${encodeURIComponent(query)}`, {
        headers: { "Content-Type": "application/json", "X-CSRF-Token": csrfToken },
      });

      const data = await response.json();

      if (data.success) {
        setClientAddresses(data.client_addresses || []);
        setAwsAddresses(data.aws_addresses || []);
      }
    } catch (error) {
      console.error("Error searching addresses:", error);
    } finally {
      setSearchingAddresses(false);
    }
  };

  // Debounce address search
  useEffect(() => {
    if (showAddressDropdown && addressSearch) {
      const timer = setTimeout(() => {
        searchAddresses(addressSearch);
      }, 300);
      return () => clearTimeout(timer);
    } else {
      setClientAddresses([]);
      setAwsAddresses([]);
    }
  }, [addressSearch, showAddressDropdown]);

  // Clear search when dropdown closes
  const closeDropdown = () => {
    setShowAddressDropdown(false);
    setAddressSearch("");
  };

  return {
    addressSearch,
    setAddressSearch,
    clientAddresses,
    awsAddresses,
    searchingAddresses,
    showAddressDropdown,
    setShowAddressDropdown,
    closeDropdown,
  };
}
